import { render, staticRenderFns } from "./Scratch.vue?vue&type=template&id=37e432ba&scoped=true&"
import script from "./Scratch.vue?vue&type=script&lang=js&"
export * from "./Scratch.vue?vue&type=script&lang=js&"
import style0 from "./Scratch.vue?vue&type=style&index=0&id=37e432ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e432ba",
  null
  
)

export default component.exports